import React, { useState, Children } from 'react';
import { motion } from 'framer-motion';
import { LogIn, KeyRound, Mail, Check, Copy } from 'lucide-react';
const LOGIN_LINK = 'https://the-jose.mn.co/sign_in';
const VSL_LINK = 'https://www.youtube.com/watch?v=XXXXXXXX';
const EMAIL_SOPORTE = 'soporte@josezabalaj.com';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function ThankYouPurchasePage() {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard.writeText('the-jose.mn.co/sign_in');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div style={{
    background: 'var(--bg-deep)',
    minHeight: '100vh',
    width: '100%',
    position: 'relative',
    overflowX: 'hidden',
    paddingBottom: '24px'
  }} data-id="element-245">
      {/* Background Elements */}
      <div className="grid-pattern" style={{
      position: 'absolute',
      inset: 0,
      opacity: 0.3,
      pointerEvents: 'none',
      zIndex: 0
    }} data-id="element-246" />
      <div style={{
      position: 'absolute',
      top: '0%',
      left: '10%',
      width: '500px',
      height: '500px',
      background: 'radial-gradient(circle, rgba(24,163,159,0.12) 0%, transparent 70%)',
      pointerEvents: 'none',
      zIndex: 0
    }} data-id="element-247" />
      <div style={{
      position: 'absolute',
      top: '40%',
      right: '5%',
      width: '400px',
      height: '400px',
      background: 'radial-gradient(circle, rgba(242,42,114,0.08) 0%, transparent 70%)',
      pointerEvents: 'none',
      zIndex: 0
    }} data-id="element-248" />

      <main style={{
      position: 'relative',
      zIndex: 1,
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '40px 16px 24px'
    }} data-id="element-249">
        <motion.div variants={containerVariants} initial="hidden" animate="visible" data-id="element-250">
          {/* HERO */}
          <motion.section variants={itemVariants} style={{
          textAlign: 'center',
          marginBottom: '32px'
        }} data-id="element-251">
            <h1 style={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 900,
            fontSize: 'clamp(30px, 6vw, 56px)',
            color: 'white',
            marginBottom: '12px',
            lineHeight: 1.1,
            letterSpacing: '-0.02em'
          }} data-id="element-252">
              ¡Tu acceso está en camino!
            </h1>

            <p style={{
            color: '#d0d0e0',
            fontSize: 'clamp(15px, 2vw, 20px)',
            fontFamily: 'Inter, sans-serif',
            lineHeight: 1.6,
            maxWidth: '600px',
            margin: '0 auto 10px'
          }} data-id="element-253">
              Sigue estos pasos para entrar a la plataforma y a la comunidad en
              minutos.
            </p>

            <p style={{
            color: '#6b6b80',
            fontSize: '13px',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-254">
              Si algo no te llega en 5–10 minutos, revisa Spam/Promociones.
            </p>
          </motion.section>

          {/* VIDEO */}
          <motion.section variants={itemVariants} style={{
          marginBottom: '32px',
          maxWidth: '720px',
          margin: '0 auto 32px'
        }} data-id="element-255">
            <div className="glass-cyan" style={{
            padding: '24px 20px',
            display: 'flex',
            flexDirection: 'column'
          }} data-id="element-256">
              <h2 style={{
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 800,
              fontSize: '22px',
              color: 'white',
              marginBottom: '6px'
            }} data-id="element-257">
                Mira este video primero
              </h2>
              <p style={{
              color: '#a0a0b0',
              fontSize: '14px',
              fontFamily: 'Inter, sans-serif',
              marginBottom: '16px'
            }} data-id="element-258">
                Te explica cómo acceder a la plataforma y aprovechar al máximo
                tu compra.
              </p>

              <div style={{
              width: '100%',
              aspectRatio: '16/9',
              borderRadius: '14px',
              overflow: 'hidden',
              position: 'relative'
            }} data-id="element-259">
                <iframe src="https://player.vimeo.com/video/1177758566?h=ec" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 'none',
                borderRadius: '14px'
              }} allow="autoplay; fullscreen; picture-in-picture" allowFullScreen title="Video de bienvenida" data-id="element-260" />
              </div>
            </div>
          </motion.section>

          {/* 3 STEPS */}
          <motion.section variants={itemVariants} style={{
          marginBottom: '32px'
        }} data-id="element-261">
            <div style={{
            textAlign: 'center',
            marginBottom: '24px'
          }} data-id="element-262">
              <h2 style={{
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 800,
              fontSize: 'clamp(22px, 4vw, 32px)',
              color: 'white',
              marginBottom: '6px',
              letterSpacing: '-0.01em'
            }} data-id="element-263">
                Completa Estos 3 Pasos Importantes (Antes De Que Te Vayas)
              </h2>
              <p style={{
              color: '#a0a0b0',
              fontSize: '15px',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-264">
                Así entras a la plataforma sin perder tiempo.
              </p>
            </div>

            <div className="purchase-steps-grid" data-id="element-265">
              {/* Step 1 */}
              <div className="glass-cyan" style={{
              padding: '24px 20px',
              display: 'flex',
              flexDirection: 'column',
              height: '100%'
            }} data-id="element-266">
                <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '16px'
              }} data-id="element-267">
                  <div style={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  background: 'rgba(24,163,159,0.15)',
                  border: '1px solid rgba(24,163,159,0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'var(--color-teal)',
                  fontFamily: 'Poppins, sans-serif',
                  fontWeight: 900,
                  fontSize: '16px'
                }} data-id="element-268">
                    1
                  </div>
                  <span style={{
                  color: 'var(--color-teal)',
                  fontWeight: 700,
                  fontSize: '13px',
                  fontFamily: 'Inter, sans-serif',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }} data-id="element-269">
                    Paso 1
                  </span>
                </div>

                <div style={{
                marginBottom: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }} data-id="element-270">
                  <LogIn size={22} color="white" data-id="element-271" />
                  <h3 style={{
                  fontFamily: 'Poppins, sans-serif',
                  fontWeight: 800,
                  fontSize: '18px',
                  color: 'white',
                  lineHeight: 1.2
                }} data-id="element-272">
                    Ve a la página de inicio de sesión
                  </h3>
                </div>

                <p style={{
                color: '#a0a0b0',
                fontSize: '14px',
                fontFamily: 'Inter, sans-serif',
                lineHeight: 1.6,
                marginBottom: '16px',
                flexGrow: 1
              }} data-id="element-273">
                  Accede a la plataforma de nuestro curso:
                </p>

                <div style={{
                background: 'rgba(0,0,0,0.4)',
                border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: '10px',
                padding: '12px 14px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '16px'
              }} data-id="element-274">
                  <span style={{
                  fontFamily: 'monospace',
                  color: 'white',
                  fontSize: '14px',
                  fontWeight: 600,
                  wordBreak: 'break-all'
                }} data-id="element-275">
                    the-jose.mn.co/sign_in
                  </span>
                  <button onClick={handleCopy} style={{
                  background: 'rgba(255,255,255,0.1)',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '8px',
                  cursor: 'pointer',
                  color: 'white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'background 0.2s'
                }} title="Copiar enlace" data-id="element-276">
                    {copied ? <Check size={18} color="var(--color-teal)" data-id="element-277" /> : <Copy size={18} data-id="element-278" />}
                  </button>
                </div>

                <a href={LOGIN_LINK} target="_blank" rel="noopener noreferrer" className="btn-cta" style={{
                display: 'block',
                textAlign: 'center',
                textDecoration: 'none',
                padding: '14px',
                fontSize: '14px'
              }} data-id="element-279">
                  IR A INICIAR SESIÓN
                </a>
              </div>

              {/* Step 2 */}
              <div className="glass-cyan" style={{
              padding: '24px 20px',
              display: 'flex',
              flexDirection: 'column',
              height: '100%'
            }} data-id="element-280">
                <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '16px'
              }} data-id="element-281">
                  <div style={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  background: 'rgba(24,163,159,0.15)',
                  border: '1px solid rgba(24,163,159,0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'var(--color-teal)',
                  fontFamily: 'Poppins, sans-serif',
                  fontWeight: 900,
                  fontSize: '16px'
                }} data-id="element-282">
                    2
                  </div>
                  <span style={{
                  color: 'var(--color-teal)',
                  fontWeight: 700,
                  fontSize: '13px',
                  fontFamily: 'Inter, sans-serif',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }} data-id="element-283">
                    Paso 2
                  </span>
                </div>

                <div style={{
                marginBottom: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }} data-id="element-284">
                  <KeyRound size={22} color="white" data-id="element-285" />
                  <h3 style={{
                  fontFamily: 'Poppins, sans-serif',
                  fontWeight: 800,
                  fontSize: '18px',
                  color: 'white',
                  lineHeight: 1.2
                }} data-id="element-286">
                    Inicia sesión con tu correo
                  </h3>
                </div>

                <p style={{
                color: '#a0a0b0',
                fontSize: '14px',
                fontFamily: 'Inter, sans-serif',
                lineHeight: 1.6
              }} data-id="element-287">
                  Haz clic en "Iniciar sesión" e ingresa el mismo correo
                  electrónico que usaste al comprar.
                </p>
              </div>

              {/* Step 3 */}
              <div className="glass-cyan" style={{
              padding: '24px 20px',
              display: 'flex',
              flexDirection: 'column',
              height: '100%'
            }} data-id="element-288">
                <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '16px'
              }} data-id="element-289">
                  <div style={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  background: 'rgba(24,163,159,0.15)',
                  border: '1px solid rgba(24,163,159,0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'var(--color-teal)',
                  fontFamily: 'Poppins, sans-serif',
                  fontWeight: 900,
                  fontSize: '16px'
                }} data-id="element-290">
                    3
                  </div>
                  <span style={{
                  color: 'var(--color-teal)',
                  fontWeight: 700,
                  fontSize: '13px',
                  fontFamily: 'Inter, sans-serif',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }} data-id="element-291">
                    Paso 3
                  </span>
                </div>

                <div style={{
                marginBottom: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }} data-id="element-292">
                  <Mail size={22} color="white" data-id="element-293" />
                  <h3 style={{
                  fontFamily: 'Poppins, sans-serif',
                  fontWeight: 800,
                  fontSize: '18px',
                  color: 'white',
                  lineHeight: 1.2
                }} data-id="element-294">
                    Revisa tu bandeja de entrada
                  </h3>
                </div>

                <p style={{
                color: '#a0a0b0',
                fontSize: '14px',
                fontFamily: 'Inter, sans-serif',
                lineHeight: 1.6,
                marginBottom: '16px',
                flexGrow: 1
              }} data-id="element-295">
                  Recibirás un correo de invitación. Haz clic en el enlace para
                  crear tu contraseña y acceder a la comunidad.
                </p>

                <div style={{
                background: 'rgba(24,163,159,0.08)',
                border: '1px solid rgba(24,163,159,0.2)',
                borderRadius: '10px',
                padding: '10px 14px'
              }} data-id="element-296">
                  <p style={{
                  color: 'var(--color-teal)',
                  fontSize: '13px',
                  fontFamily: 'Inter, sans-serif',
                  margin: 0,
                  lineHeight: 1.5
                }} data-id="element-297">
                    <strong data-id="element-298">Tip:</strong> Revisa Spam/Promociones y busca
                    "Mighty Networks" si no lo ves.
                  </p>
                </div>
              </div>
            </div>
          </motion.section>

          {/* SUPPORT STRIP */}
          <motion.section variants={itemVariants} style={{
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(255,255,255,0.08)',
          borderRadius: '14px',
          padding: '24px 20px',
          marginBottom: '32px'
        }} data-id="element-299">
            <h3 style={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 800,
            fontSize: '18px',
            color: 'white',
            marginBottom: '12px'
          }} data-id="element-300">
              ¿Problemas para entrar?
            </h3>
            <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            color: '#a0a0b0',
            fontSize: '14px',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-301">
              <p style={{
              margin: 0
            }} data-id="element-302">
                1) Confirma que usaste el mismo correo con el que compraste
              </p>
              <p style={{
              margin: 0
            }} data-id="element-303">
                2) Revisa Spam/Promociones
              </p>
              <p style={{
              margin: 0
            }} data-id="element-304">
                3) Si no te llega el correo de invitación, escríbenos a:{' '}
                <a href={`mailto:${EMAIL_SOPORTE}`} style={{
                color: 'var(--color-teal)',
                textDecoration: 'none'
              }} data-id="element-305">
                  {EMAIL_SOPORTE}
                </a>
              </p>
            </div>
          </motion.section>
        </motion.div>
      </main>

      {/* FOOTER */}
      <footer style={{
      borderTop: '1px solid rgba(255,255,255,0.08)',
      padding: '24px 16px',
      position: 'relative',
      zIndex: 1
    }} data-id="element-306">
        <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '12px',
        textAlign: 'center'
      }} data-id="element-307">
          <div style={{
          display: 'flex',
          gap: '24px',
          marginBottom: '4px'
        }} data-id="element-308">
            <a href="#" style={{
            color: '#6b6b80',
            fontSize: '13px',
            fontFamily: 'Inter, sans-serif',
            textDecoration: 'none'
          }} data-id="element-309">
              Términos
            </a>
            <a href="#" style={{
            color: '#6b6b80',
            fontSize: '13px',
            fontFamily: 'Inter, sans-serif',
            textDecoration: 'none'
          }} data-id="element-310">
              Privacidad
            </a>
          </div>
          <p style={{
          color: '#6b6b80',
          fontSize: '13px',
          fontFamily: 'Inter, sans-serif',
          margin: 0
        }} data-id="element-311">
            Soporte: {EMAIL_SOPORTE}
          </p>
          <p style={{
          color: '#4a4a5a',
          fontSize: '13px',
          fontFamily: 'Inter, sans-serif',
          margin: 0
        }} data-id="element-312">
            © 2026 De Cero a Afiliado. Todos los derechos reservados.
          </p>
        </div>
      </footer>

      <style data-id="element-313">{`
        .purchase-steps-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 16px;
        }
        
        @media (min-width: 900px) {
          .purchase-steps-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;
          }
        }
      `}</style>
    </div>;
}